<script setup lang="ts">
const props = defineProps<{
  averageRating?: number | null
  reviewsCount?: number
}>();

const { n } = useI18n();

const averageRating = computed(() => {
  if (!props.averageRating) return ``;
  return n(props.averageRating, { style: 'decimal', maximumFractionDigits: 1 });
});
</script>

<template>
  <div class="flex gap-xs items-center">
    <div class="flex gap-2xs items-center">
      <Icon
        name="iad-icon:star"
        class="text-rating size-5"
      />
      <strong
        v-if="averageRating"
        class="font-semibold"
      >
        {{ averageRating }}/5
      </strong>
    </div>
    <small
      v-if="reviewsCount"
      class="text-sm"
      v-text="$t(`reviews.count.label`, { count: n(reviewsCount) })"
    />
    <Icon
      name="iad-icon:logo-immodvisor"
      class="w-[90px] h-auto"
      title="Logo Immodvisor"
    />
  </div>
</template>
